import { CheckboxField } from 'lib/iterable-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { body2Medium, caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p232: pxToRem(232),
};

// Checkbox Form Field Component
export const CheckboxContainer = styled.div`
  display: grid;
  grid-template-areas:
    'checkbox title'
    'checkbox description'
    'checkbox additional-content';
  align-items: baseline;
  grid-template-columns: ${spacing.base} 1fr; /* Fixed width for checkbox, flexible content */
  gap: 0 ${spacing.threeQuarter};
`;

export const StyledCheckboxField = styled(CheckboxField)`
  grid-area: checkbox;
  padding: ${spacing.eighth};
`;

export const CheckboxTitle = styled.div`
  ${body2Medium}
  grid-area: title;
  color: ${colors.textPrimary};
`;

export const CheckboxDescription = styled.div`
  ${caption}
  color: ${colors.textSecondary};
`;

export const CheckboxAdditionalContent = styled.div`
  grid-area: additional-content;
`;

export const TimeSeriesRadioGroupContainer = styled.div`
  margin-top: ${spacing.base};

  div[data-test='radio-list-settings.chartDisplay'] {
    justify-content: start;
    gap: ${spacing.plusHalf};
  }
`;

export const LocationFormFieldContainer = styled(FormField)`
  margin-top: ${spacing.half};
  div[data-test='basic-select'] {
    width: ${customSpacing.p232};
  }
`;

export const AudienceFormFieldContainer = styled(FormField)`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${spacing.half};

  div[data-test='basic-select'] {
    width: ${customSpacing.p232};
    margin-right: ${spacing.plusHalf};
  }

  div[data-test='form-field-error-text'] {
    flex-basis: 100%;
  }
`;
